import React from 'react';
import { Typography, Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { translate } from 'translations/translator';
const getTranslation = key => translate('lessonAssignment', key);

export const OuterContainerHeader = ({ numOfAssigned, dateRange, assigned }) => {
  const classes = useStyles()();

  return (
    <Container className={classes.container}>
      <Typography variant="h4" style={{ fontWeight: 500 }}>
        {assigned
          ? `${getTranslation('thisWeeksAssignments')} (${numOfAssigned})`
          : numOfAssigned > 0 && `${getTranslation('assignAnotherDay')}`}
      </Typography>
      <Typography variant="h6" style={{ fontWeight: 300, lineHeight: '2.25rem' }}>
        {assigned && dateRange}
      </Typography>
    </Container>
  );
};

const useStyles = () =>
  makeStyles(() => ({
    container: {
      display: 'flex !important',
      justifyContent: 'space-between',
      width: '82vw !important',
      maxWidth: '1356px !important',
      marginTop: '32px',
      padding: '0 !important'
    }
  }));
